import { useCanvasStore } from '../stores/useCanvasStore'
import { useOrderStore } from '../stores/useOrderStore'
import { useUiStore } from '../stores/useUiStore'
import { loadImage } from './useImageLoader'

export function useAddDeco() {
    const canvasStore = useCanvasStore()
    const orderStore = useOrderStore()
    const uiStore = useUiStore()

    async function addFrame(imageUrl, decoId) {
        if (canvasStore.cntStamp >= canvasStore.maxStamp) return
        uiStore.setLoading(true)
        try {
            const img = await loadImage(imageUrl)
            const size = canvasStore.canvasSize
            const r = canvasStore.labelRegion
            // フレームはラベル領域にフィット
            const ratio = img.naturalWidth / img.naturalHeight
            let w, h
            if (ratio > 1) {
                w = r.width
                h = r.width / ratio
            } else {
                h = r.height
                w = r.height * ratio
            }
            // 既存フレームを削除してから追加
            const existing = canvasStore.objects.find(o => o.objectType === 'frame')
            if (existing) {
                orderStore.decrementDecoCount(existing.decoId)
                canvasStore.removeObject(existing.id)
            }
            canvasStore.addObject({
                objectType: 'frame',
                src: imageUrl,
                x: r.x + r.width / 2,
                y: r.y + r.height / 2,
                width: w,
                height: h,
                rotation: 0,
                decoId,
            })
            orderStore.incrementDecoCount(decoId)
            uiStore.hidePanel()
        } finally {
            uiStore.setLoading(false)
        }
    }

    async function addStamp(imageUrl, decoId) {
        if (canvasStore.cntStamp >= canvasStore.maxStamp) return
        uiStore.setLoading(true)
        try {
            const img = await loadImage(imageUrl)
            const size = canvasStore.canvasSize
            const ratio = img.naturalWidth / img.naturalHeight
            const max = size * 0.3
            const w = ratio >= 1 ? max : max * ratio
            const h = ratio >= 1 ? max / ratio : max
            canvasStore.addObject({
                objectType: 'stamp',
                src: imageUrl,
                x: canvasStore.labelCenterX,
                y: canvasStore.labelCenterY,
                width: w,
                height: h,
                rotation: 0,
                decoId,
            })
            orderStore.incrementDecoCount(decoId)
            uiStore.hidePanel()
        } finally {
            uiStore.setLoading(false)
        }
    }

    return { addFrame, addStamp }
}
